<!--
  Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (permission()) {
<div class="container">
  <h2>Clear Caches</h2>

  @if (loading) {
    <div class="loading">
      Clearing caches...
    </div>
  }

  @if (!loading && message) {
    <div class="message success">
      {{ message }}
    </div>
  }

  @if (!loading && error) {
    <div class="message error">
      {{ error }}
    </div>
  }

  @if (!loading && !message && !error) {
    <div class="message">
      Click the button below to clear all caches.
    </div>
  }

  <div class="actions">
    <p-button label="Clear Caches" (click)="clearCaches()" [loading]="loading" class="gm-btn-primary"></p-button>
  </div>
</div>
}


